let Api = {

	"REPLENISH_SAMPLECOUNT": "/dc/replenish/sampleCount", //样品数
	"AUTHENTICATION_SELCATELIST": "/dc/authentication/selCateList", //产品认证类别占比
	"REPLENISH_FINDMAPLISTFORRZTYPE": "/dc/replenish/findMapListForRzType", //地图根据认证类型查询所在省份及产品数量
	
	"GEOPRO_FINDLIST": "/quality/n/geoPro/findList", //认证中心产品
    
	"GEOPRO_SELPRODSTATIS": "/quality/n/geoPro/selProdStatis", //

	"FLOORINDEX_FINDMAPLISTFORPROAREA": "/dc/n/floorIndex/findMapListForProArea", //

	"GEOPRO_SELRZPRODCOUNT": "/quality/n/geoPro/selRzProdCount", //

	"REPLENISH_OVERVIEW": "/dc/replenish/overview", //



	





    
	
	
	


   
	

  

  

}
module.exports = Api